const checkIdExistsInSearch = (obj, id) => {
    if (obj && obj.length > 0) {
        const isInCart = obj.filter(obj_item => obj_item?.candidate?.id === id)
        return isInCart?.length
    }
}

export default checkIdExistsInSearch
